/* global Chart */

(function($) {
    'use strict';

    var PieChart = function(el) {
        this.$el = $(el);
        this.id = this.$el.prop('id');
        this.numericID = this.id.slice(-1);

        this.pieData = [
            {
                value: 0,
                color: '#84bb36'
            },
            {
                value: 100,
                color: '#f8f5f1'
            }
        ];

        this.pieOptions = {
            segmentShowStroke: false,
            animation: false,
            showTooltips: false
        };

        this.ctx = document.getElementById(this.id).getContext('2d');

        this.init();
    };

    PieChart.prototype = {
        init: function() {
            this.bindEvents();
        },

        bindEvents: function() {
            var that = this;
            var pie = new Chart(this.ctx).Pie(this.pieData, this.pieOptions);
            var numericID = this.id.slice(-1);

            $(
                '.improvement-' + numericID
            ).bind('DOMNodeInserted DOMSubtreeModified DOMNodeRemoved', function() {
                that.setPie(pie, numericID);
            });
        },

        setPie: function(pie, id) {
            var improvement = $('.improvement-' + id).html();
            var percent = Number(improvement.slice(0, -1));

            if (percent <= 0) {
                pie.segments[0].value = 0;
                pie.segments[1].value = 100;
            } else {
                var minus = 100 - percent;
                pie.segments[0].value = percent;
                pie.segments[1].value = minus;
            }

            pie.update();
        }
    };

    $.fn.piechart = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('piechart');

            if (!data) {
                $this.data('piechart', (data = new PieChart(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };

    $.fn.piechart.Constructor = PieChart;
})(jQuery);
